<template>
  <div class="wrap" :class="{ 'is-header': $route.meta.header }">
    <!-- Page Header -->
    <transition>
      <page-header
        ref="pageHeader"
        @main-icon-click="handleMain"
        @back-icon-click="handleBack"
      ></page-header>
    </transition>
    <transition>
      <router-view ref="routerView"></router-view>
    </transition>
  </div>
</template>
<script>
import PageHeader from './components/PageHeader';

export default {
  components: {
    PageHeader,
  },

  data: () => ({}),
  computed: {},
  mounted() {},
  methods: {
    handleBack() {
      const name = this.$route.name;
      const hash = this.$route.hash;
      if (name === 'Board.Detail' && hash) {
        this.$router.replace({ name: 'Board.List' });
      } else if (name === 'Knowhow.Detail' && hash) {
        this.$router.replace({ name: 'Knowhow.List' });
      } else {
        this.$router.go(-1);
      }
    },
    handleMain() {
      this.$router.push({ path: '/' }).catch(err => {});
    },
  },
};
</script>
